
import {  gsap,Back,Power3 } from "gsap";
import { Presentation, PresentationState } from "../../../../core/gameflow/controller/Presentation";
import { GameData } from "../../../server/data/GameData";
import { GameSetting } from '../../../../core/setting/GameSetting';
import { ArrayHelper } from "../../../../core/utils/ArrayHelper";
import { Helper } from "../../../../core/utils/Helper";
import { SoundManager } from "../../../config/sound/SoundManager";
import { SoundConfig } from "../../../config/sound/SoundConfig";
import { SanEngineManager } from '../../../engine/SanEngineManager';
import { ReelState } from "../../../../core/reel/ReelEngineView";
import { SanQuentin2 } from "../../../SanQuentin2";
import { SanEngineController } from "../../../engine/SanEngineController";
import { RevealerManager } from "../../../modules/revealer/RevealerManager";
import { ReelSymbolStates } from "../../../../core/reel/symbol/ReelSpriteSymbolArea";
import { AnimationEffects } from "../../../../core/effects/AnimationEffects";
import { Logger } from "@nolimitcity/slot-launcher/bin/utils/Logger";
import { GameConfig } from "../../../config/base/GameConfig";
import { BaseModel } from "../../../server/base/BaseModel";
import { WildAnimationJump } from '../../../modules/jumpingWild/JumpingWildSymbol';


export class StopPresentation extends Presentation {

    protected animationTl: gsap.core.Timeline;
    protected scatterPos: number[];
    protected countScatter: number = 0;

    protected attentionStart:number = -1;
    protected ammScatterLanded:number = 0;
    protected lastScatter:number = 0;

    protected debVal:number = 0;

    protected possibleWin: boolean[][] = [];
    protected isFSSUPER: boolean = false;

    protected ignoreFeatureAttention:boolean;
    protected nearWinMap:boolean[][];

    // _isSuperGambling: boolean = false;

    protected get basicStopDelay():number[]{
        
        let delay:number[] = [0, 0.3, 0.6, 0.7, 0.8];
        // this._gameData.Win.allBetWayWinData.longest > 2 ? [0, 0.3, 0.6, 1.2, 1.7] : [0, 0.3, 0.6, 0.7, 0.8];
        if(SanEngineManager.isQuickStop || GameSetting.isFastSpin || this.ignoreFeatureAttention){
            delay = [0,0,0,0,0];
        }else{
            let exTraDel = 0;
            if(this.nearWinMap[0].find(v => v))
                for(let k = 3; k < delay.length;k++){
                    if(this.nearWinMap[k].find(v => v)){
                        exTraDel += 0.6;
                    }
                    delay[k] += exTraDel;
                }
        }

        const interactDurr =  GameSetting.isFastSpin ? 0.5 : 1;
        if(!this.ignoreFeatureAttention && this.attentionStart != -1 && !SanEngineManager.isQuickStop){
            let del = 0;
            let delOffset = 0;
            let ammScatters = 0;
            delay.forEach((v,i) => {
                delay[i] += del;
                if(this.scatterPos[i] != -1){
                    ammScatters++;
                    if(ammScatters > 1) delOffset += interactDurr;
                }
                del += delOffset;
            });
        }

        return  delay;
    }
  
    setGameData(data: GameData): void {
        super.setGameData(data);
        this.countScatter = 0;
        this.debVal = -1;
        this.scatterPos = data.Reel.scatterPositions;

        this.nearWinMap = data.Win.CreateNearWinMap();
        this.attentionStart = -1;
        this.ammScatterLanded = 0;
        this.ignoreFeatureAttention = this._gameData.raw.featureBuy && BaseModel.buyFeatureName !== "LUCKY_DRAW" && this._gameData.isNormalMode;

        if(!GameSetting.isFastSpin && !this.ignoreFeatureAttention){
            data.Reel.scatterPositions.forEach((ScatPos,reel) => {
                if(this.attentionStart != -1) return;
                if(this.ammScatterLanded == 2){
                    this.attentionStart = reel;
                }
                this.ammScatterLanded += ScatPos != -1 ? 1 : 0;
            })
        }
        
        for(let kk = this._gameData.Reel.scatterPositions.length-1; kk >= 0;kk--){
            if(this._gameData.Reel.scatterPositions[kk] >= 0){
                this.lastScatter = kk;
                break;
            }
        }
        RevealerManager.setResData(this._gameData.raw.topReel, this._gameData.raw.bottomReel, this._gameData.Reel.mysteryRevealSymbol, !data.isNormalMode);
        SanEngineManager.parseData(data.Reel);
    }
 
    preStart(): void {
        this.animationTl = Helper.setTimeline(this.animationTl);
        this.ammScatterLanded = 0;
    }

    // Add animation offset that couldn't be calculated.
    protected addAnimOffset(): void {
        if (this.animationTl.isActive()) {
            this.timeline.to(this, { duration: this.animationTl.duration() - this.animationTl.time() }, 0);
        }
    }

    // Add Start Offset.
    protected addStartReelOffset(): boolean {
        const remaining: number = SanEngineManager.remainingStartEngineOffset();
        this.timeline.to(this, { duration: remaining }, 0);
        return !!remaining;
    }

    // Add animation offset that couldn't be calculated.
    protected addRemainingReelStop(): void {
        this.timeline.to(this, { duration: SanEngineManager.lastSpinningTime || SanEngineManager.remainingAnimatedReelTime }, 0);
    }

    protected createStopSpins(): void {
        SanEngineManager.RAll((rc: SanEngineController) => rc.createStop({
            stops: () => this.onStop(rc),
            bounce: () => {
                this.onBounce(rc);
                this.playBounceSound(rc.reelID); 
            },
            stopped: () => this.onStopped(rc)
        }, this.shouldBeAttentionStop(rc.reelID)));
    }

    private shouldBeAttentionStop(reelID:number):boolean{
        // if(this._isSuperGambling) return true;
        return !this.ignoreFeatureAttention && this.attentionStart != -1 && reelID >= this.attentionStart && !SanEngineManager.isQuickStop;
    }

    protected readyToDefineStop(): boolean {

        if (!this.isActive) {
            this.addAnimOffset();
            this.addRemainingReelStop();
            return false;
        }

        if (this.addStartReelOffset()) return false;

        this.setPlayable(false);

        return true;
    }

    playBounceSound(reelID: number): void {
        SoundManager.playReelStop(reelID, SanEngineManager.isQuickStop || GameSetting.isFastSpin);
        if (SanEngineManager.lastStopOrder === reelID) {
            if(!this._gameData.isNormalMode) SoundManager.stopSoundEffect(SoundConfig.REELS_SPINNING);
            
            if(!this.ammScatterLanded)
                SoundManager.stopSoundEffect(SoundConfig.REELS_SPINNING);
            else
                SoundManager.fadeSound(SoundConfig.REELS_SPINNING,400,0.6,1);
            if(this.attentionStart != -1){

                if(this._gameData.isNormalMode)
                    SoundManager.stopSoundEffect(SoundConfig.SCATTER_ATTENTION,400);

                if(this._gameData.nextModeIsNormal)
                    SoundManager.playSoundEffect(SoundConfig.SCATTER_ATTENTION_MISS);
            }
        }
    }

    public createPresentation(enableSkip: Function) {
        enableSkip(!SanEngineManager.isQuickStop);
        if (this.readyToDefineStop()) {

            this.createStopSpins();

            const delay: number[] = this.basicStopDelay;

            SanEngineManager.stopReels(delay);

            this.setPlayable(false);
        }
    }

    protected onStop(rc: SanEngineController): void { 
        rc.changeAlpha(0, rc.stopDuration);
        if (this._gameData!.Reel.WildPositions[rc.reelID].length > 0){
            const wildPos = this._gameData!.Reel.WildPositions[rc.reelID][0];
            rc.getSymbol(wildPos)!.changeState({ state: ReelSymbolStates.NORMAL, sym: "W_S",forceState:true });
        }
        this.barOnStop(rc);
    }

    protected barOnStop(rc: SanEngineController){
        if(this._gameData.Reel.scatterPositions[rc.reelID] == -1){
            this.barAnim(rc);
        }
    }
    
    protected barAnim(rc: SanEngineController):void{
        const lstTime: number = this.animationTl.totalTime();
        this.animationTl.to(this,{duration:0.1},lstTime);
        this.animationTl.add(() => {
            RevealerManager.getTopBar(rc.reelID).shuffle(false);
            RevealerManager.getBotBar(rc.reelID).shuffle(false);
        }, lstTime + rc.stopDuration/2 );
    }

    protected onBounce(rc: SanEngineController): void { 
        this.scatterLand(rc);

        if(this._gameData.isNormalMode)
            this.onPreWinMarked(rc);
    }

    protected onPreWinMarked(rc: SanEngineController):void{
        if(rc.reelID < 2 || !this.nearWinMap[0].find(v => v)) return;
        if(rc.reelID == 2){
            for(let k = 0; k <= rc.reelID; k++){
                SanEngineManager.AllReels[k].AllWindowSymbols.forEach(sym =>{
                    if(!this.nearWinMap[k][sym.posID[0]] && !sym.isScatter){
                        sym.markNonWin(true,0.45,0.3);
                    }
                })
            }
        }else{
            rc.AllWindowSymbols.forEach(sym =>{
                if(!this.nearWinMap[rc.reelID][sym.posID[0]] && !sym.isScatter){
                    sym.markNonWin(true,0.45,0.3);
                }
            })
        }
    }

    protected wildLand(rc: SanEngineController): void {

        if (this._gameData!.Reel.WildPositions[rc.reelID].length > 0) {

            const wildPos = this._gameData!.Reel.WildPositions[rc.reelID][0];
            let lstTime: number = this.animationTl.totalTime();

            this.animationTl.add(() => {
                rc.getSymbol(wildPos)?.NormalWildLand();
                SoundManager.playSoundEffect(SoundConfig.WILD_SPLIT,undefined,true);
            }, lstTime);

            // const playNormal = !SanEngineManager.isQuickStop && !GameSetting.isFastSpin;
            posToAffect(wildPos).forEach(v => {
                const restSym = rc.getSymbol(v)!;
                const dist = (Math.abs(v - wildPos) * GameConfig.SPLIT_OFFSET) - GameConfig.SPLIT_OFFSET;
                if(restSym.isNormalSym){
                    this.animationTl.add(() => {restSym.doSplit()}, lstTime + dist );
                }
            });
            this.animationTl.to(this,{duration:0.3},lstTime + GameConfig.SPLIT_OFFSET*2);

            SoundManager.playSoundEffect(SoundConfig.WILD_LAND,undefined,true);
        }

        function posToAffect(origin:number):number[]{
            return [0,1,2,3].filter((v) =>  v != origin);
        }
    }

    protected scatterLand(rc: SanEngineController): void {
        const scattPos = this._gameData.Reel.scatterPositions[rc.reelID];

        if (scattPos >= 0) {
            const scatterSoundIndx = this._gameData.isNormalMode ? Math.min(this.ammScatterLanded, SoundConfig.SCATTER_LAND.length-1) : 0;

            if(this.ignoreFeatureAttention || GameSetting.isFastSpin || SanEngineManager.isQuickStop){
                if(this.lastScatter == rc.reelID){
                    SoundManager.playSoundEffect(SoundConfig.SCATTER_LAND[scatterSoundIndx]);
                }
            }else
                SoundManager.playSoundEffect(SoundConfig.SCATTER_LAND[scatterSoundIndx]);

            this.animationTl.add(rc.getSymbol(this._gameData.Reel.scatterPositions[rc.reelID])!.onScatterLands(),this.animationTl.totalTime());
            this.ammScatterLanded++;
            if(this.ammScatterLanded > 1 && !this.ignoreFeatureAttention){
                AnimationEffects.Shake({
                    obj: SanQuentin2.counter.parent,
                    duration: 1.2,
                    hertz:120,
                    x:0.6,
                    y:1.8,
                    Intensity: this.ammScatterLanded * 2,
                    positionCb: () => new PIXI.Point(360,360),
                    ease: Power3.easeOut,
                    reverseEase:true
                })
            }
        }
        if (this.ammScatterLanded > 1 && this._gameData.isNormalMode && this.attentionStart != -1) {
            if(rc.reelID >= this.attentionStart){
                SanEngineManager.getReel(rc.reelID).playAttentionDiv(false);
                rc.AllWindowSymbols.forEach(sym => {
                    if(!sym.isScatter && !this.nearWinMap[rc.reelID][sym.posID[0]]) sym.markNonWin(true,0.45);
                })
                
            }else if(this.attentionStart === rc.reelID+1){
                if(this._gameData.isNormalMode){
                    SoundManager.playSoundEffect(SoundConfig.SCATTER_ATTENTION,Infinity);
                }
                SanEngineManager.RSWindow((reel,sym) => {
                    if(reel.reelID >= reel.reelID){
                        if(!sym.isScatter && !this.nearWinMap[reel.reelID][sym.posID[0]])
                            sym.markNonWin(true,0.45);
                    }
                })
            }
            if (SanEngineManager.AllReels.length - 1 != rc.reelID) {
                SanEngineManager.getReel(rc.reelID + 1).playAttentionDiv(true);
            }
        }
    }

    protected onStopped(rc: SanEngineController): void {
        this.wildLand(rc);

        // this.debVal++;
        // if(this.debVal != rc.reelID) console.error("Faan");
    }

    skip(): void {
        this.setPlayable(true);
        SanEngineManager.isQuickStop = true;
        super.skip();
    }

    isFinished(): boolean {
        const notFinished: boolean = !(SanEngineManager.getFirstStoppingReel() >= 0 || SanEngineManager.findReelWithState(ReelState.STEP) >= 0)
        if (!notFinished) return notFinished;
        
        if (this.animationTl.isActive()) return false;

        return true;
    }

    done() {
        if(!this.ammScatterLanded)
            SanQuentin2.xWaysCounter.setValue(undefined,this._gameData.raw.totalWays,0.1);

        SanQuentin2.reelEngineManager.applyMask(false);
        SanEngineManager.revealer.applyIndiviMask(false);
        Logger.log("Stop Done");
    }
}